<app-dialog [config]="data.config" (actionButtonClicked)="onFormSubmit($event)">
    <ng-container dialog-title>Sell Order</ng-container>

    <ng-container dialog-process-in-progress *ngIf="orderForm && orderForm.form">
        <div class="container">
            <form [formGroup]="orderForm.form">
                <div [ngClass]="{'mb-3': orderForm.controls.product.errors.length > 0}">
                    <app-select
                        [formControlName]="orderForm.controls.product.name"
                        [control]="orderForm.controls.product"
                    ></app-select>
                </div>
                <div class="row order-details-wrapper">
                    <div class="col-lg-10 col-md col">
                        <div class="card">
                            <div class="card-body">
                                <span class="label">{{availableQuantityText}}</span>
                                <span class="value">{{availableQuantity|formatAmount:''}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    [ngClass]="{
                        'mb-3': orderForm.controls.quantity.errors.length > 0,
                        'text-success': orderForm.controls.quantity.value > 0,
                        'text-danger': orderForm.controls.quantity.value < 0
                    }"
                    class="order-quantity-input"
                >
                    <div class="app-input fill">
                        <app-amount-input
                            [onlyIntegers]="this.model.isInteger"
                            [control]="orderForm.controls.quantity"
                            [formControlName]="orderForm.controls.quantity.name"
                        ></app-amount-input>
                    </div>
                </div>
                <div *ngIf="model.product?.sellPrice" class="row order-details-wrapper">
                    <div class="col-lg-6 col-md col">
                        <div class="card">
                            <div class="card-body">
                                <span class="label product-price-desc">
                                    SELL Price
                                </span>
                                <span class="value"> {{ model.product.sellPrice.value }}  </span>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="model.totals?.amount" class="col-lg-6 col-md col">
                        <div class="card">
                            <div class="card-body">
                                <span class="label product-price-desc">Amount</span>
                                <span class="value">{{ model.totals.amount | formatDecimal }}</span>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="model.totals?.quantity" class="col-lg-6 col-md col">
                        <div class="card">
                            <div class="card-body">
                                <span class="label product-price-desc">Quantity</span>
                                <span class="value">{{ model.totals.quantity | formatDecimal }}</span>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="model.totals?.fee" class="col-lg-6 col-md col">
                        <div class="card">
                            <div class="card-body">
                                <span class="label product-price-desc">Fee</span>
                                <span class="value">{{ model.totals.fee | formatDecimal }}</span>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="model.totals?.interest" class="col-lg-6 col-md col">
                        <div class="card">
                            <div class="card-body">
                                <span class="label product-price-desc">Interest</span>
                                <span class="value">{{ model.totals.interest | formatDecimal }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 col">
                        <div *ngIf="model.totals.insufficient" class="text-danger">
                            Insufficient resources
                        </div>
                        <div *ngIf="model.totals.warning" class="text-danger">
                            Something is wrong
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </ng-container>
</app-dialog>
